export default __webpack_public_path__ + "c74c5bdb2d93df9211f5b9d69b85d970.png";